import { sampleCategories, allQuestions } from "../lib/sampleQuestions";
import { useLang } from "../hooks/useLang";

type Props = {
  activeQuestion: string;
  onPick: (q: string) => void;
};

export default function Sidebar({ activeQuestion, onPick }: Props) {
  const { t } = useLang();
  return (
    <aside className="sidebar">
      <h2>{t("sidebar_title")} · {allQuestions.length}</h2>
      {sampleCategories.map((cat) => (
        <details key={cat.title} className="sidebar-cat">
          <summary>
            <span>{cat.title}</span>
            <span className="count">{cat.questions.length}</span>
          </summary>
          <ul className="q-list">
            {cat.questions.map((q) => (
              <li key={q}>
                <button
                  className={`q-item ${q === activeQuestion ? "active" : ""}`}
                  onClick={() => onPick(q)}
                  title={t("sidebar_pick_hint")}
                >
                  {q}
                </button>
              </li>
            ))}
          </ul>
        </details>
      ))}
    </aside>
  );
}
